import { QueryStatus } from '../../../../../types'
import {OperacionLEP} from '../types/types'
import { useEffect, useState } from 'react'
import {HttpLEP} from "../api/httpLEP";

export const useOperacionLEP = (idOperacion: number) => {
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
    const [operacion, setOperacion] = useState<OperacionLEP>()

    useEffect(() => {
        setStatus(QueryStatus.Loading)

        HttpLEP.get(idOperacion)
            .then(data => {
                setOperacion(data)
                setStatus(QueryStatus.Success)
            })
            .catch(() => setStatus(QueryStatus.Error))
    }, [idOperacion])

    return { status, operacion }
}
